import React from "react";
import {Panel} from "react-bootstrap";
import Component from "../../components/AscComponent";
import SetBreadCrumb from "../Elements/AscElements/SetBreadCrumb";

export default class Setting extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            show: false,
            eval_flag: false,
        };
    }

    componentDidMount = async () => {
        await this.getCompanyControlByCompanyId("CALL_EVAL", "CALL_EVAL_OPTION");
    };

    getCompanyControlByCompanyId = async (function_id, parameter_id) => {
        const company_id = this.props.userInfo && this.props.userInfo.company_id;
        if (!company_id) return;

        try {
            const result = await this.ascAxios(
                "post",
                `${this.reactContainerPath}/getCompanyControlCallEvalByCompanyId`,
                {
                    company_id,
                    function_id,
                    parameter_id,
                }
            );

            const flag = !!(result.data && result.data.parameter_value === "Y");

            this.setState({
                eval_flag: flag,
            });
        } catch (err) {
            console.error(err);
            this.showErrorObjectMesssage(err);
        }
    };

    panelOnClick = (path) => {
        this.props.historyPush({
            pathname: path,
        });
    };

    render() {
        const callHistoryAnalysisSettingPermission = this.getPermission(
            "CallHistoryAnalysisSetting",
            "Setting"
        );

        const ipRestrictionPermission = this.getPermission(
            "IpRestriction",
            "Setting"
        );

        const isCallHistoryAnalysisSettingVisible = !!(
            callHistoryAnalysisSettingPermission &&
            callHistoryAnalysisSettingPermission.read &&
            (callHistoryAnalysisSettingPermission.scope_code === "system" || this.state.eval_flag)
        );

        const isIpRestrictionVisible = !!(ipRestrictionPermission && ipRestrictionPermission.read);
        const hasAnyVisiblePanel = isCallHistoryAnalysisSettingVisible || isIpRestrictionVisible;

        return (
            <React.Fragment>
                <SetBreadCrumb displayItems={[{ name: this.props.langText.Body.Setting }]} />
                {!hasAnyVisiblePanel && (
                    <div className="no-readable-panels-message text-danger">
                        {this.props.langText.Message.NoVisiblePanelByAuth}
                    </div>
                )}
                <div className="flex-style">
                    {isCallHistoryAnalysisSettingVisible &&
                        <Panel
                            bsStyle="info"
                            bsSize="large"
                            className="auto-call-select"
                            onClick={() => this.panelOnClick("Setting/CallHistoryAnalysisSetting")}
                        >
                            <Panel.Heading>
                                <Panel.Title componentClass="h1">
                                    {this.props.langText.Body.SettingCallHistoryAnalysis}
                                </Panel.Title>
                            </Panel.Heading>
                            <Panel.Body className="body-auto-call-select">
                                {this.props.langText.Body.SettingCallHistoryAnalysisDescription}
                            </Panel.Body>
                        </Panel>
                    }
                    {isIpRestrictionVisible &&
                        <Panel
                            bsStyle="info"
                            bsSize="large"
                            className="auto-call-select"
                            onClick={() => this.panelOnClick("Setting/IpRestriction")}
                        >
                            <Panel.Heading>
                                <Panel.Title componentClass="h1">
                                    {this.props.langText.Body.SettingIpRestriction}
                                </Panel.Title>
                            </Panel.Heading>
                            <Panel.Body className="body-auto-call-select">
                                {this.props.langText.Body.SettingIpRestrictionDescription}
                            </Panel.Body>
                        </Panel>
                    }
                </div>
            </React.Fragment>
        );
    }
}

